import 'react-awesome-slider/dist/styles.css';
import 'react-awesome-slider/dist/custom-animations/fold-out-animation.css';

import React, { Fragment } from 'react';
import { inject } from 'mobx-react';
import { NavLink } from 'react-router-dom';

const injectWithStores = inject('artistStore');

export default injectWithStores(
	({ artistStore, match: { params: { id } } }) => {

		if (artistStore.isLoading) {

			return (<h1>Loading...</h1>);
		}
		
		const artist = artistStore.getItemByID(id);
		return (
			<div style={{marginTop: '7vh'}} className="grid-x grid-padding-x">
				{
					
					artist.albums.map(({ artwork, name, _id }) => (
						<div key={ id } className="cell shrink text-center">
							<NavLink
								to={ `/album/${_id}` }
								className="image medium"
								style={
									{
										display: 'block',
										backgroundImage: `url("${artwork}")`,
										width: '11.5rem',
										height: '11.5rem',
										boxShadow: 'rgba(0, 0, 0, 0.4) 0px 4px 20px'
									}
								}>
							</NavLink>
							<p className="primary-font margin-top-1" style={{maxWidth: '11.5rem', fontSize: '1.4em'}}>{ name }</p>
						</div>
					))
				}
			</div>
		);
	}
);
